module.exports = __webpack_public_path__ + "static/media/guitar.535a91ed.svg";